import { createFileRoute } from '@tanstack/react-router';
import ShowFilePage from 'src/features/plugins/outlook/taskpane/show-file/page';

export const Route = createFileRoute('/plugins/outlook/taskpane/show-file')({
  component: ShowFilePage,
});
